import React from "react";
import Snap from "snapsvg-cjs";

import pelvisNodes from "../images/svg/pelvisNodes.svg";
import "./Animation.css";

// mina is not exported from snapsvg-cjs
const mina = window.mina;

class PelvisNodes extends React.Component {

	componentDidMount() {
		// Set ready to false
		this.props.setReadyState(false);
		// Allows to assign this to an attr in parent
		this.props.onRef(this);
		// Load SVG into the component
		this.svg = Snap(document.querySelector("#pelvisNodes"));
		Snap.load(
			pelvisNodes,
			function (data) {
				this.svg.append(data);
				// Set ready to true
				this.props.setReadyState(true);
			}.bind(this),
		);
    } 

	animate() {
		var arrowTop = Snap.select("#pelvisNodes #arrowTop");
		var arrowBottomLeft = Snap.select("#pelvisNodes #arrowBottomLeft");
		var arrowBottomRight = Snap.select("#pelvisNodes #arrowBottomRight");
		//arrowMask.attr({fill: "#fff"})
		var height = 250;
		var scale = 15;
		//arrowBottom.attr({ mask: arrowMask });
		
		var animation_1 = () => Snap.animate(
			0, 
			1,
			function (step) {
				var m = new Snap.Matrix();
				var h = height*step;
				m.translate(0, h);
				arrowTop.attr({transform: m}); 
			}.bind(this),	
			1000,
			mina.easeinout,
			function () {
				animation_2();
			}
		);
		
		var animation_2 = () => Snap.animate(
			0, 
			1,
			function (step) {
				var m = new Snap.Matrix();
				var n = new Snap.Matrix();
				var s = scale*step;
				var h = 4*step;
				m.scale(s,s,195.3, 371.45);
				n.scale(s,s,345.7, 371.45);
				arrowBottomLeft.attr({ transform: m.translate(0,h)} );
				arrowBottomRight.attr({ transform: n.translate(0,h)} );

			}.bind(this),	
			1000,
			mina.easeinout,
			function() {
				// Animation complete
				this.props.onAnimationEnd();
			}.bind(this)
		);

		animation_1();
		
	}
    
	render() {
		return (
            <svg id="pelvisNodes"
				viewBox="97 -1150 350 1913"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="xMidYMid meet">
			</svg>
		);
	}
}

export default PelvisNodes;


// WEBPACK FOOTER //
// ./src/animation/PelvisNodes.js